import React, { memo, useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';

let remaining_time = 0;
const CountdownTimer = memo ( function CountdownTimer({
	time, sectionTimedOut,
	reduceSectionTime, setReduceSectionTime
}) {
    const intStatus = useSelector((state) => state.intStatus);
	const [countdown, setCountdown] = useState(parseInt(parseFloat(time) * 60));
	const [id, setID] = useState(0);
    const [isOnline, setIsOnline] = useState(true);

    useEffect(() => {
    const connection = typeof intStatus === "undefined" ? true : intStatus;
    setIsOnline(connection);
  }, [intStatus]);

  useEffect(() => {
    if (isOnline) {
      beginCountdown();
    } else {
      clearInterval(id); // Pause timer when offline
    }
  }, [isOnline]);

	// useEffect(() => {

	// 	beginCountdown();
	// }, []);

	useEffect(() => {
		if (countdown <= 0 && isOnline) {
			remaining_time = 0;
			clearInterval(id);
			setCountdown(0);
			sectionTimedOut();
		} else {
			remaining_time = countdown;
		}
	}, [countdown ,  isOnline]);

	useEffect(() => {
		if (reduceSectionTime > 0) {
			if ((countdown - reduceSectionTime) <= 0) {
				setCountdown(0);
			} else {
				setCountdown(prev => (prev - reduceSectionTime));
			}
			setReduceSectionTime(0);
		}
	}, [reduceSectionTime]);


	const beginCountdown = () => {
		let interval_id = setInterval(() => {
			setCountdown(prev => (prev - 1));
		}, 1000);

		setID(interval_id);
	};

	const remainingTime = () => {
		return countdown;
	}

	return (
    <div className="timeRemaining">
      {/* {!isOnline && (
        <div className="network-warning-timer">
          <i className="fa fa-wifi"></i> Offline - Timer Paused
        </div>
      )} */}
      <p>
        <i className="fa fa-clock-o"></i> 
        <span>Time Remaining: {Math.floor(countdown / 60)}:{parseInt(countdown % 60)}</span>
      </p>
    </div>
  );
});

export default CountdownTimer;
export { remaining_time };